import axios from "axios";
import baseURL from "../configs/api";

export const post_EmailTemplate = (data: any, userId: number, tenantId: string) => {
    return axios({
        url: `${baseURL}emailTemplate?userId=${userId}`,
        method: "POST",
        headers: {
            'X-Tenant-ID': tenantId,
            "Content-Type": "application/json"
        },
        withCredentials: true,
        data: data
    }).then(response => response.data);
}

export const put_EmailTemplate = (data: any, userId: number, tenantId: string) => {
    return axios({
        url: `${baseURL}emailTemplate?userId=${userId}`,
        method: "PUT",
        headers: {
            'X-Tenant-ID': tenantId,
            "Content-Type": "application/json"
        },
        withCredentials: true,
        data: data
    }).then(response => response.data);
}

export const delete_EmailTemplate = (id: number, userId: number, tenantId: string) => {
    return axios({
        url: `${baseURL}emailTemplate`,
        method: "DELETE",
        headers: {
            'X-Tenant-ID': tenantId,
        },
        params: { id: id, userId: userId }
    }).then(response => response.data);
}

export const DoesEmailTemplateTypeExist = (emailTemplateTypeId: number, tenantId: string) => {
    return getFetch(`emailTemplate/DoesEmailTemplateTypeExist/${emailTemplateTypeId}`, tenantId)
}

export const getEmailTemplates = (tenantId: string) => {
    return getFetch(`emailTemplate`, tenantId);
}

export const getEmailTemplateById = (primaryKey: number, tenantId: string) => {
    return getFetch(`emailTemplate/${primaryKey}`, tenantId)
}

const getFetch = (url: string, tenantId: string, params = {}) => {
    return axios({
        url: baseURL + url,
        method: "GET",
        headers: {
            'X-Tenant-ID': tenantId,
        },
        params: params
    }).then(response => response.data);
}